import { createContext, useContext } from 'react'

import type { SideMenuContextValue } from './types'

export const SideMenuContext = createContext<SideMenuContextValue | null>(null)

export const useSideMenuContext = (): SideMenuContextValue => {
  const context = useContext(SideMenuContext)
  if (!context) {
    throw new Error('useSideMenuContext must be used within a <SideMenu> component')
  }
  return context
}
